import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { SendToCaseComponent } from './send-to-case/send-to-case.component';
import { UnassignedFileComponent } from './unassigned-file/unassigned-file.component';
import { CaseFilesService } from '../shared/services/casefiles.service';
import { Subscription } from 'rxjs';
import { ModalService } from '../shared/services/modal.service';

@Component({
  selector: 'app-unassigned-files',
  templateUrl: './unassigned-files.component.html',
  styleUrls: ['./unassigned-files.component.scss']
})
export class UnassignedFilesComponent implements OnInit {

  files: any[] = [];
  selectedFile: any;
  allowMultiSelect: boolean = false;
  selectedItems: any[] = [];

  @ViewChildren(UnassignedFileComponent) unassignedFiles!: QueryList<UnassignedFileComponent>;

  refreshSubscription: Subscription;

  constructor(private caseFilesService: CaseFilesService,
              public modalService: ModalService) {

    this.loadFiles();

    this.refreshSubscription = this.caseFilesService.refreshUnassignedCaseFilesObservable.subscribe(() => {
      this.loadFiles();
    });
  }

  ngOnInit(): void {
  }

  loadFiles(){

    this.caseFilesService.getUnassignedFiles().subscribe(response => {
      this.files = response.files;
    });

  }

  dblClickItem(item: any){

    this.caseFilesService.getFile(item.caseFileId).subscribe(response => {

      // For PDFs and images
      const fileURL = URL.createObjectURL(response.body);
      window.open(fileURL, '_blank');

    });
  }

  openSendToCase(){
    const modalRef = this.modalService.openWithOptions(SendToCaseComponent, {size: 'lg'});
    modalRef.componentInstance.file = this.selectedFile;
  }

  ngOnDestroy(){
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }


}
